import React from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    text: <span key="1" data-id="element-302">
          Le mandé un solo mensaje… y me respondió con un audio larguísimo.{' '}
          <strong data-id="element-303">Nunca había pasado.</strong>
        </span>,
    initial: 'M',
    color: 'bg-rose-200'
  }, {
    text: <span key="2" data-id="element-304">
          Se estaba alejando… usé uno de los mensajes y{' '}
          <strong data-id="element-305">volvió a escribirme como antes.</strong>
        </span>,
    initial: 'L',
    color: 'bg-gold-200'
  }, {
    text: <span key="3" data-id="element-306">
          Estoy en shock… <strong data-id="element-307">respondió al instante</strong> y con interés
          real.
        </span>,
    initial: 'C',
    color: 'bg-pink-200'
  }, {
    text: <span key="4" data-id="element-308">
          Ahora <strong data-id="element-309">él inicia las conversaciones</strong> y busca verme más.
        </span>,
    initial: 'A',
    color: 'bg-rose-300'
  }];
  return <section className="py-12 md:py-16 bg-dark" data-id="element-310">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-312">
          <h2 className="text-3xl xl:text-4xl font-bold text-white mb-4" data-id="element-313">
            Resultados Reales de Mujeres que Ya lo Usan
          </h2>
          <div className="w-24 h-1 bg-rose-500 mx-auto rounded-full" data-id="element-314"></div>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-315">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 p-8 rounded-2xl border border-white/10 flex flex-col h-full" data-id="element-316">
              <div className="flex space-x-1 mb-4" data-id="element-317">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-318" />)}
              </div>
              <p className="text-xl font-medium italic mb-8 flex-1 text-gray-200" data-id="element-319">
                {t.text}
              </p>
              <div className="flex items-center mt-auto pt-4 border-t border-white/10" data-id="element-320">
                <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center font-bold text-dark shadow-sm`} data-id="element-321">
                  {t.initial}
                </div>

                <div className="ml-3" data-id="element-322">
                  <p className="text-sm font-bold text-white" data-id="element-323">
                    Usuaria Verificada
                  </p>
                  <p className="text-xs text-green-400 font-medium" data-id="element-324">
                    Compra Confirmada
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}